module.exports = __webpack_public_path__ + "img/icon-question.43ba3890.svg";